import React from 'react';
import styled from 'styled-components';
import Picture from '../image/CloudFrontPicture';

import Dots from './Level';

const SewpatSizesLevel = ({ sewpat }) => {
    const Flex = styled.div`
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
    `;

    const FlexItem = styled.div`
        max-width: 50vw;
        
        & .stolo-bold {
          font-weight: 700;
        }
    `;

    const firstSize = sewpat.sizes[0];
    const lastSize = sewpat.sizes[(sewpat.sizes.length - 1)];

    return (
           <Flex>
               <FlexItem>
                   <span className='stolo-bold'>Grössen:</span> {[firstSize, '-', lastSize]}<br />
               </FlexItem>
               <FlexItem>
                   <span className='stolo-bold'>Level</span>
                   <Dots level={parseInt(sewpat.level, 10)} />
               </FlexItem>
           </Flex>
    );
};

export default SewpatSizesLevel;



// WEBPACK FOOTER //
// ./src/components/sewpat/SewpatSizesLevel.js